// ── HTML Escaping ──

let _htmlDiv;

export function html(str) {
  if (str == null) return '';
  if (!_htmlDiv) _htmlDiv = document.createElement('div');
  _htmlDiv.textContent = String(str);
  return _htmlDiv.innerHTML;
}

// ── Truncation ──

export function truncate(str, len) {
  return str && str.length > len ? str.slice(0, len) + '\u2026' : str;
}

// ── Severity Sorting ──

export const SEVERITY_SORT_ASC = { critical: 0, high: 1, medium: 2, low: 3 };
export const SEVERITY_SORT_DESC = { critical: 4, high: 3, medium: 2, low: 1 };
export const SEVERITY_ORDER = ['critical', 'high', 'medium', 'low'];

export function sortBySeverityAsc(a, b) {
  return (SEVERITY_SORT_ASC[a.severity] ?? 99) - (SEVERITY_SORT_ASC[b.severity] ?? 99);
}

export function sortBySeverityDesc(a, b) {
  return (SEVERITY_SORT_DESC[b.severity] ?? 0) - (SEVERITY_SORT_DESC[a.severity] ?? 0);
}

// ── Port Analysis Constants ──

export const SENSITIVE_PORTS = [21, 22, 23, 3389, 3306, 5432, 27017, 6379, 9200, 11211, 8080, 8443];

export const PORT_NAMES = {
  21: 'FTP', 22: 'SSH', 23: 'Telnet', 25: 'SMTP', 80: 'HTTP', 443: 'HTTPS',
  3389: 'RDP', 3306: 'MySQL', 5432: 'PostgreSQL', 27017: 'MongoDB',
  6379: 'Redis', 9200: 'Elasticsearch', 11211: 'Memcached', 8080: 'HTTP-Alt', 8443: 'HTTPS-Alt',
};

// ── Country Coordinates (centroids) ──

export const COUNTRY_COORDS = {
  US: { lat: 39.8283, lon: -98.5795 }, CA: { lat: 56.1304, lon: -106.3468 },
  GB: { lat: 55.3781, lon: -3.4360 }, DE: { lat: 51.1657, lon: 10.4515 },
  FR: { lat: 46.6034, lon: 1.8883 }, IT: { lat: 41.8719, lon: 12.5674 },
  ES: { lat: 40.4637, lon: -3.7492 }, NL: { lat: 52.1326, lon: 5.2913 },
  RU: { lat: 61.5240, lon: 105.3188 }, CN: { lat: 35.8617, lon: 104.1954 },
  JP: { lat: 36.2048, lon: 138.2529 }, KR: { lat: 35.9078, lon: 127.7669 },
  IN: { lat: 20.5937, lon: 78.9629 }, BR: { lat: -14.2350, lon: -51.9253 },
  AU: { lat: -25.2744, lon: 133.7751 }, ZA: { lat: -30.5595, lon: 22.9375 },
  MX: { lat: 23.6345, lon: -102.5528 }, AR: { lat: -38.4161, lon: -63.6167 },
  SE: { lat: 60.1282, lon: 18.6435 }, NO: { lat: 60.4720, lon: 8.4689 },
  DK: { lat: 56.2639, lon: 9.5018 }, FI: { lat: 61.9241, lon: 25.7482 },
  PL: { lat: 51.9194, lon: 19.1451 }, CH: { lat: 46.8182, lon: 8.2275 },
  AT: { lat: 47.5162, lon: 14.5501 }, BE: { lat: 50.8503, lon: 4.3517 },
  IE: { lat: 53.4129, lon: -8.2439 }, PT: { lat: 39.3999, lon: -8.2245 },
  CZ: { lat: 49.8175, lon: 15.4730 }, HU: { lat: 47.1625, lon: 19.5033 },
  GR: { lat: 39.0742, lon: 21.8243 }, RO: { lat: 45.9432, lon: 24.9668 },
  UA: { lat: 48.3794, lon: 31.1656 }, TR: { lat: 38.9637, lon: 35.2433 },
  IL: { lat: 31.0461, lon: 34.8516 }, AE: { lat: 23.4241, lon: 53.8478 },
  SA: { lat: 23.8859, lon: 45.0792 }, EG: { lat: 26.8206, lon: 30.8025 },
  NG: { lat: 9.0820, lon: 8.6753 }, KE: { lat: -0.0236, lon: 37.9062 },
  SG: { lat: 1.3521, lon: 103.8198 }, HK: { lat: 22.3193, lon: 114.1694 },
  TW: { lat: 23.6978, lon: 120.9605 }, NZ: { lat: -40.9006, lon: 174.8860 },
  ID: { lat: -0.7893, lon: 113.9213 }, MY: { lat: 4.2105, lon: 101.9758 },
  PH: { lat: 12.8797, lon: 121.7740 }, TH: { lat: 15.8700, lon: 100.9925 },
  VN: { lat: 14.0583, lon: 108.2772 }, CL: { lat: -35.6751, lon: -71.5430 },
  CO: { lat: 4.5709, lon: -74.2973 }, PE: { lat: -9.1900, lon: -75.0152 },
  PA: { lat: 8.5380, lon: -80.7821 }, CR: { lat: 9.7489, lon: -83.7534 },
};

export const COUNTRY_NAMES = {
  US: 'United States', GB: 'United Kingdom', DE: 'Germany', FR: 'France',
  IT: 'Italy', ES: 'Spain', NL: 'Netherlands', RU: 'Russia', CN: 'China',
  JP: 'Japan', KR: 'South Korea', IN: 'India', BR: 'Brazil', AU: 'Australia',
  CA: 'Canada', MX: 'Mexico', AR: 'Argentina', ZA: 'South Africa',
  SE: 'Sweden', NO: 'Norway', DK: 'Denmark', FI: 'Finland', PL: 'Poland',
  CH: 'Switzerland', AT: 'Austria', BE: 'Belgium', IE: 'Ireland',
  PT: 'Portugal', CZ: 'Czech Republic', HU: 'Hungary', GR: 'Greece',
  RO: 'Romania', UA: 'Ukraine', TR: 'Turkey', IL: 'Israel', AE: 'UAE',
  SA: 'Saudi Arabia', EG: 'Egypt', NG: 'Nigeria', KE: 'Kenya',
  SG: 'Singapore', HK: 'Hong Kong', TW: 'Taiwan', NZ: 'New Zealand',
  ID: 'Indonesia', MY: 'Malaysia', PH: 'Philippines', TH: 'Thailand',
  VN: 'Vietnam', CL: 'Chile', CO: 'Colombia', PE: 'Peru',
};

// ── Fetch with Timeout and Retry ──

export async function fetchWithTimeout(url, options = {}, timeoutMs = 30000) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, { ...options, signal: controller.signal });
    clearTimeout(timer);
    return res;
  } catch (err) {
    clearTimeout(timer);
    throw err;
  }
}

export async function fetchWithRetry(url, options = {}, timeoutMs = 30000) {
  try {
    return await fetchWithTimeout(url, options, timeoutMs);
  } catch (err) {
    // Retry once on timeout / network errors
    console.warn(`[fetch] attempt 1 failed for ${url}: ${err.message}, retrying...`);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const res = await fetch(url, { ...options, signal: controller.signal });
      clearTimeout(timer);
      return res;
    } catch (err2) {
      clearTimeout(timer);
      throw err2;
    }
  }
}

// ── Concurrency Pool ──

export async function concurrencyPool(items, worker, limit = 5) {
  let idx = 0;
  let completed = 0;
  let failures = 0;
  const total = items.length;

  async function runner() {
    while (idx < total) {
      const i = idx++;
      try {
        await worker(items[i], i);
      } catch (err) {
        failures++;
        console.warn('[concurrencyPool] worker failed:', err);
      }
      completed++;
    }
  }

  await Promise.all(
    Array.from({ length: Math.min(limit, total) }, runner)
  );

  return { completed, failures };
}
